
interface PageMetaProps {
  title: string;
  description: string;
  url?: string;
  image?: string;
}

// Route head definitions own these tags for SSR and navigation. Retain the
// call-site contract without emitting duplicate React-hoisted metadata.
const PageMeta = (_props: PageMetaProps) => null;

export default PageMeta;
